import { render, staticRenderFns } from "./Psycho.vue?vue&type=template&id=1c594f93&scoped=true&"
import script from "./Psycho.vue?vue&type=script&lang=js&"
export * from "./Psycho.vue?vue&type=script&lang=js&"
import style0 from "./Psycho.vue?vue&type=style&index=0&id=1c594f93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c594f93",
  null
  
)

export default component.exports